import React from "react";
import { FiInfo } from "react-icons/fi"; // Info icon

const Tooltip = ({ text }) => (
  <div className="relative group inline-block">
    <FiInfo className="text-gray-400 hover:text-gray-600 cursor-pointer" />
    <span className="absolute hidden group-hover:block bottom-full left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded-md whitespace-nowrap">
      {text}
    </span>
  </div>
);

export default Tooltip;